import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Modal } from "@mui/material";

import { useDocumentById, useNotify } from "hooks";
import { Drawer, Loading, BillModal } from "components";

import { ADD_DOCUMENT_BILL_PAGE } from "../consts";

export const AddDocumentBillPage = () => {
  const navigate = useNavigate();
  const notify = useNotify();
  const { documentId } = useParams<{ [ADD_DOCUMENT_BILL_PAGE.KEY]: string | undefined }>();
  const { data: document, isLoading, error } = useDocumentById(documentId);

  const [isOpen, setIsOpen] = useState<boolean>(true);

  const onClose = useCallback(async () => {
    navigate(-1)
    setIsOpen(false);
    window.localStorage.removeItem("utilityBillFormData");
  }, [navigate]);

  useEffect(() => {
    if (!isLoading && (error !== null || document === null || document === undefined)) {
      navigate(-1);
      notify.error("Manual data entries are disabled for system-generated bills.");
    }
  }, [document, navigate, notify, error, isLoading]);

  return isLoading ? (
    <Modal open={isOpen} onClose={onClose}>
      <Box sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}>
        <Loading />
      </Box>
    </Modal>
  ) : (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      zIndex={1300}
      customPaperProps={{ width: "100%", height: "auto", overflow: "hidden" }}
      expandedWidth='100%'
    >
      {document && (
        <BillModal
          document={document}
          isLoading={isLoading}
          onClose={onClose}
        />
      )}
    </Drawer >
  );
};
